import { Component, Input, ContentChildren, QueryList, AfterContentInit} from '@angular/core';
import { CustomSubTabComponent } from '../custom-subtab/custom-tab.component';

@Component({
  selector: 'custom-tab',
  templateUrl: 'custom-tabs.html'
})
export class CustomTabComponent implements AfterContentInit {
  @Input() title: string;
  @Input() active = false;

  @ContentChildren(CustomSubTabComponent) subtabs: QueryList<CustomSubTabComponent>;

  public selectTab(tab: CustomSubTabComponent): void {
    this.subtabs.toArray().forEach(item => item.active = false);
    tab.active = true;
  }

  ngAfterContentInit() {
    const activeTabs = this.subtabs.filter((tab) => tab.active);

    if (activeTabs.length === 0) {
      this.selectTab(this.subtabs.first);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/custom-tabs/custom-tab/custom-tab.component.ts